import type { FaireProductEntity } from "../../entity_types/product";

export const p_keuh4ve44x: FaireProductEntity = {
  token: "p_keuh4ve44x",
  type: "product",
  name: "E. Frannie Pack (Seaglass)",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7a9b83a4903602540009c4df59bb2a88147842240f2eec15621875ef2718a2ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/145d52f2d57b0413046f691219d1b97f695332b683279d72721cfba8fec08493.jpeg",
    "https://cdn.faire.com/fastly/bfaa2b424a2b5ee6cd63665a69842b19de191a4e9af03d729beeee9373311acd.png",
    "https://cdn.faire.com/fastly/90619d575d1f1a13a19d1cb3c2da25593612f8d7b3446fad4067f773cc668f60.png",
    "https://cdn.faire.com/fastly/ee762efc7edfc6d0532a954f640f4c3cde490c7e0123731acf43b7b7c86c0112.png",
    "https://cdn.faire.com/fastly/548df67b6ce8efee4e8a5dba9269aaa1ab995e973f498cabb7d81aa74981790f.png",
  ],
  priceDollars: 9,
  description:
    "Meet your Little Notes® sidekick! The E. Frannie Pack is ready for bags, cars, coat pockets...leave a note under someone's windshield. Under someone's doormat. A smile for the bank teller at the other end of that frightening, traveling tube. Anywhere joy might be needed. It snuggly fits about 25 Little Notes®. The E.Frannie Pack is cute, practical, and the perfect gift for anyone who loves sprinkling more joy into the world.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:02.471Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
